import { online } from './sources';

export type CiteType = 'web' | 'decision' | 'texte' | 'article' | 'ouvrage';

export const CITE_TYPES: { id: CiteType; label: string }[] = [
  { id: 'web', label: 'Page web / rapport en ligne' },
  { id: 'decision', label: 'Décision de justice' },
  { id: 'texte', label: 'Loi, code, directive' },
  { id: 'article', label: 'Article de revue' },
  { id: 'ouvrage', label: 'Livre / ouvrage' },
];

export interface Field { id: string; label: string; ph: string }

export const FIELDS: Record<CiteType, Field[]> = {
  web: [
    { id: 'author', label: 'Auteur ou organisme', ph: 'INSEE  ou  DUPONT, Marie' },
    { id: 'title', label: 'Titre de la page', ph: 'Les micro-entrepreneurs en 2023' },
    { id: 'publisher', label: 'Site / éditeur', ph: 'insee.fr' },
    { id: 'date', label: 'Date de publication', ph: '12 mars 2024' },
    { id: 'url', label: 'Lien (URL)', ph: 'https://…' },
  ],
  decision: [
    { id: 'country', label: 'Pays / organisation', ph: 'FRANCE' },
    { id: 'court', label: 'Juridiction', ph: 'Cour de cassation, chambre sociale' },
    { id: 'ref', label: 'Type et numéro', ph: 'Arrêt n° 19-13.316' },
    { id: 'date', label: 'Date', ph: '4 mars 2020' },
    { id: 'url', label: 'Lien (URL)', ph: 'https://…' },
  ],
  texte: [
    { id: 'country', label: 'Pays / organisation', ph: 'FRANCE  ou  UNION EUROPÉENNE' },
    { id: 'title', label: 'Intitulé du texte', ph: 'Loi n° 2016-1088 du 8 août 2016 relative au travail…' },
    { id: 'publisher', label: 'Source officielle', ph: 'Légifrance  ou  EUR-Lex' },
    { id: 'url', label: 'Lien (URL)', ph: 'https://…' },
  ],
  article: [
    { id: 'author', label: 'Auteur(s) — NOM, Prénom', ph: 'DUPONT, Marie' },
    { id: 'title', label: "Titre de l'article", ph: 'Le travail de plateforme…' },
    { id: 'journal', label: 'Revue', ph: 'Droit social' },
    { id: 'year', label: 'Année', ph: '2021' },
    { id: 'issue', label: 'Volume, numéro', ph: 'n° 3' },
    { id: 'pages', label: 'Pages', ph: 'p. 210-218' },
    { id: 'url', label: 'DOI ou lien (facultatif)', ph: 'https://doi.org/…' },
  ],
  ouvrage: [
    { id: 'author', label: 'Auteur(s) — NOM, Prénom', ph: 'DUPONT, Marie' },
    { id: 'title', label: 'Titre', ph: "L'économie des plateformes" },
    { id: 'edition', label: 'Édition (facultatif)', ph: '2e éd.' },
    { id: 'place', label: "Lieu d'édition", ph: 'Paris' },
    { id: 'publisher', label: 'Éditeur', ph: 'La Découverte' },
    { id: 'year', label: 'Année', ph: '2020' },
    { id: 'isbn', label: 'ISBN (facultatif)', ph: '978-2-…' },
  ],
};

// NOM en capitales (partie avant la virgule), comme le veut l'ISO 690
const upAuthor = (a: string) => a.split(';').map((p) => {
  const [last, ...rest] = p.trim().split(',');
  return rest.length ? `${last.trim().toUpperCase()}, ${rest.join(',').trim()}` : last.trim().toUpperCase();
}).filter(Boolean).join(' ; ');

const join = (parts: (string | undefined | false)[]) => parts.filter(Boolean).join('. ').replace(/\.\./g, '.');

export function buildCitation(type: CiteType, f: Record<string, string>): string {
  const v = (k: string) => (f[k] || '').trim();
  const tail = v('url') ? ` ${online(v('url'))}` : '';
  switch (type) {
    case 'web':
      return `${join([upAuthor(v('author')), v('title'), v('publisher') && v('date') ? `${v('publisher')}, ${v('date')}` : v('publisher') || v('date')])}${tail ? `${tail}` : '.'}`;
    case 'decision':
      return `${join([upAuthor(v('country')), v('court'), [v('ref'), v('date') && `du ${v('date')}`].filter(Boolean).join(' ')])}${tail || '.'}`;
    case 'texte':
      return `${join([upAuthor(v('country')), v('title'), v('publisher')])}${tail || '.'}`;
    case 'article': {
      const ref = [v('year'), v('issue'), v('pages')].filter(Boolean).join(', ');
      return `${join([upAuthor(v('author')), v('title'), v('journal'), ref])}${v('url') ? ` ${online(v('url'))}` : '.'}`;
    }
    default: {
      const pub = [v('place'), v('publisher')].filter(Boolean).join(' : ');
      return `${join([upAuthor(v('author')), v('title'), v('edition'), [pub, v('year')].filter(Boolean).join(', '), v('isbn') && `ISBN ${v('isbn')}`])}.`;
    }
  }
}
